import type { SearchLocation } from '@/scopes/search/search/infrastructure/api/types'

import type { ComponentPropsWithoutRef } from 'react'
import { tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

type LocationTagProps = ComponentPropsWithoutRef<'p'> & {
  locations: SearchLocation[]
}

LocationTag.displayName = 'LocationTag'

const StyledLocationTag = styled(Typography)`
  align-items: center;
  color: ${tok('primitives_color_neutral_600')};
`

export function LocationTag({ locations, ...attributes }: LocationTagProps) {
  return (
    <StyledLocationTag $variant="body-s-regular-flat" {...attributes}>
      <span>
        {locations
          .map(location => location.name)
          .reverse()
          .join(', ')}
      </span>
    </StyledLocationTag>
  )
}
